import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl, tablet_s } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../../global/commonStyle';

interface Props {
  isSelected?: boolean;
  isAlignedBottom?: boolean;
}

export const MainDiv = styled.div<Props>`
  width: 100%;
  padding: var(--space-12) var(--space-16);
  border-radius: var(--border-radius-8);
  border: 0.5px solid ${({ isSelected }) => (isSelected ? 'var(--border-secondary)' : 'var(--border-primary)')};
  display: flex;
  flex-direction: column;
  gap: var(--space-14);
  height: -webkit-fill-available;
  cursor: pointer;
  ${mobile_xl(css`
    width: -webkit-fill-available;
  `)}
`;

export const SectionDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
`;

// top section
export const InputSection = styled.div<Props>`
  display: flex;
  align-items: ${({ isAlignedBottom }) => (isAlignedBottom ? 'flex-end' : 'center')};
  gap: var(--space-12);
  justify-content: space-between;
  ${mobile_xl(css`
    &.show-users {
      flex-direction: column;
      align-items: flex-start;
      gap: var(--space-6);
    }
  `)}
`;

export const Label = styled.p`
  margin: var(--space-0);
  ${Typography.body_lg_medium}
  color: var(--text-primary);
`;

export const PricingSection = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
  white-space: nowrap;
  ${tablet_s(css`
    white-space: normal;
  `)}
`;

export const Price = styled.p`
  margin: var(--space-0);
  ${Typography.heading_xl_semibold};
  color: var(--text-primary);
`;

export const PriceTag = styled.p`
  margin: var(--space-0);
  ${Typography.body_md};
  color: var(--text-primary);
`;

export const UserCard = styled.div`
  opacity: 1;
  padding: var(--space-4) var(--space-4) var(--space-4) var(--space-8);
  ${AlignCenter}
  gap: var(--space-4);
  border-radius: var(--border-radius-6);
  border: 0.5px solid var(--border-primary);
  white-space: nowrap;
  ${mobile_xl(css`
    white-space: normal;
  `)}
`;

export const UserText = styled.p`
  margin: var(--space-0);
  ${Typography.body_sm};
  color: var(--text-secondary);
`;
export const UserCount = styled.p`
  margin: var(--space-0);
  ${Typography.body_md};
  color: var(--text-primary);
  padding-inline: var(--space-6);
  background-color: var(--background-secondary);
  border-radius: var(--border-radius-4);
`;

// Feature List
export const FeaturePoints = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
`;

export const Icon = styled.div`
  ${FlexCenter}
`;

export const Feature = styled.p`
  margin: var(--space-0);
  ${Typography.body_md};
  color: var(--text-secondary);
`;
